/* mm-pdp-gallery v1.5 (2026-09-30: "+N more" opens the rest of the photos in the grid, "Show fewer photos" closes them; v1.4 2026-09-28: carat/length/chain tags read from the file name; "Worn at …" caption once in the grid; v1.3 custom.model_worn caption; v1.2 pairs + SEO wording) — Modern Mangal PDP gallery. Pairs with snippets/mm-pdp-gallery.liquid + assets/mm-pdp.css */
(() => {
  const root = document.querySelector('[data-mm-gallery]');
  if (!root || root.dataset.mmInit) return;
  root.dataset.mmInit = '1';

  const data = JSON.parse(root.querySelector('[data-mm-gallery-json]').textContent);
  const grid = root.querySelector('[data-mm-grid]');
  const dots = root.querySelector('[data-mm-dots]');
  const lb = document.querySelector('[data-mm-lb]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isPhone = () => window.matchMedia('(max-width: 989px)').matches;

  // ---------- options ----------
  const optIdx = (re) => data.options.findIndex((o) => re.test(o));
  const iColor = optIdx(/colou?r|metal|gold/i);
  const iCarat = optIdx(/carat/i);
  const caratCount = iCarat > -1 ? new Set(data.variants.map((v) => v.options[iCarat])).size : 0;
  const GOLD = (v) => {
    v = String(v || '').toLowerCase();
    return /rose/.test(v) ? 'rose' : /white/.test(v) ? 'white' : /yellow/.test(v) ? 'yellow' : null;
  };
  const num = (s) => parseFloat(String(s).replace(/[^0-9.]/g, ''));
  const tag = (t, k) => {
    const m = String(t || '').match(new RegExp('\\[' + k + ':([^\\]]+)\\]', 'i'));
    return m ? m[1].trim() : null;
  };
  // v1.4: file-name tags, e.g. modern-mangal-malini-mangalsutra-on-model-ct-0-5-len-16-chain-1-3.jpg -> ct 0.5, len 16, chain 1.3
  const ftag = (f, k) => {
    const m = String(f || '').toLowerCase().match(new RegExp('-' + k + '-(\\d+(?:-\\d+)?)(?=[-_.]|$)'));
    return m ? m[1].replace('-', '.') : null;
  };
  const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const cleanAlt = (s) => String(s || '').replace(/\[[a-z]+(:[^\]]*)?\]/gi, '').trim();

  // ---------- classify media ----------
  const featured = new Map(); // media id -> gold of the variants that feature it
  data.variants.forEach((v) => {
    if (v.fm && iColor > -1) {
      const g = GOLD(v.options[iColor]);
      if (g && !featured.has(v.fm)) featured.set(v.fm, g);
    }
  });
  let runGold = null;
  const media = data.media
    .map((m) => {
      const text = ((m.alt || '') + ' ' + (m.file || '')).toLowerCase();
      const it = Object.assign({}, m, { text });
      it.ct = ftag(m.file, 'ct') || tag(m.alt, 'ct');
      it.len = ftag(m.file, 'len') || tag(m.alt, 'len');
      it.chain = ftag(m.file, 'chain') || tag(m.alt, 'chain');
      it.hide = /\[hide\]/.test(text);
      it.video = m.type === 'video' || m.type === 'external_video';
      it.model = it.video || !!it.ct || /\[model\]/.test(text) || /model/.test(text);
      if (featured.has(m.id)) runGold = featured.get(m.id);
      if (!it.model) {
        const phrase = text.match(/(yellow|white|rose)[\s_-]+gold/);
        it.gold =
          GOLD(tag(m.alt, 'color')) ||
          (phrase && phrase[1]) ||
          (/yellow/.test(text) ? 'yellow' : /rose/.test(text) ? 'rose' : /white/.test(text) ? 'white' : runGold);
        it.role =
          tag(m.alt, 'role') ||
          (featured.has(m.id)
            ? 'front'
            : /close|top[\s_-]?view|side[\s_-]?view/.test(text)
            ? 'closeup'
            : /flat|full[\s_-]?(view|length)|full necklace|top[\s_-]?down|complete[\s_-]view|side[\s_-]?profile|angled[\s_-]?(view[\s_-]of[\s_-]the[\s_-])?pair/.test(text)
            ? 'flatlay'
            : 'other');
      }
      return it;
    })
    .filter((m) => !m.hide);

  // ---------- current variant ----------
  const byId = new Map(data.variants.map((v) => [String(v.id), v]));
  let cur = byId.get(String(data.current)) || data.variants[0];
  const selGold = () => (iColor > -1 && cur ? GOLD(cur.options[iColor]) : null);
  const selCt = () => (iCarat > -1 && cur ? String(cur.options[iCarat]) : null);

  // ---------- build the ordered list ----------
  let state = null;
  function compute() {
    const g = selGold();
    const ct = selCt();
    const pool = media.filter((m) => !m.model && (!g || !m.gold || m.gold === g));
    const take = (arr, fn) => {
      const i = arr.findIndex(fn);
      return i > -1 ? arr.splice(i, 1)[0] : null;
    };
    const models = media.filter((m) => m.model && !m.ct && !m.video);
    const videos = media.filter((m) => m.video);
    const caratShot = ct ? media.find((m) => m.ct && num(m.ct) === num(ct)) || null : null;

    const main = (cur && cur.fm && take(pool, (m) => m.id === cur.fm)) || take(pool, (m) => m.role === 'front') || pool.shift() || null;
    const t2 = caratShot || models.shift() || null;
    const t3 = videos.shift() || models.shift() || null;
    const t4 = take(pool, (m) => m.role === 'closeup') || pool.shift() || null;
    const t5 = take(pool, (m) => m.role === 'flatlay') || pool.shift() || null;
    const tiles = [main, t2, t3, t4, t5].filter(Boolean);
    const rest = [...pool, ...models, ...videos];
    // v1.1: small tiles always come in pairs (rows of 2). Odd count: pull the next photo in from "+ more",
    // or, when there is none, move the last small tile into the viewer.
    if ((tiles.length - 1) % 2 === 1) {
      if (rest.length) tiles.push(rest.shift());
      else if (tiles.length > 2) rest.unshift(tiles.pop());
    }
    return { g, ct, tiles, rest, all: tiles.concat(rest), t2, caratShot };
  }

  const gaugeFor = (m, ct) => {
    if (m.chain) return m.chain.replace(/[^0-9.]/g, '') + ' mm';
    if (caratCount < 4) return '';
    const c = num(ct);
    return c <= 1 ? '1.3 mm' : c <= 2 ? '1.5 mm' : '1.7 mm';
  };
  function caption(m, s, full) {
    const yg = m.model && s.g && s.g !== 'yellow';
    if (s.caratShot && m === s.caratShot) {
      let c = 'Worn at ' + num(s.ct) + ' ct · ' + (m.len ? num(m.len) + ' in' : '16 in') + (yg ? ' · shown in yellow gold' : '');
      if (full) {
        const gauge = gaugeFor(m, s.ct);
        c += (gauge ? ' · ' + gauge + ' chain' : '') + ' · digital rendering, shown to scale';
      }
      return c;
    }
    // v1.3: every model photo/video says what the model wears (product metafield custom.model_worn, e.g. "1 ct · 16 in")
    if (m.model && data.worn) return 'Worn at ' + data.worn + (yg ? ' · shown in yellow gold' : '');
    return yg ? 'Shown in yellow gold' : '';
  }

  const sized = (src, w) => (/width=\d+/.test(src) ? src.replace(/width=\d+/, 'width=' + w) : src + (src.includes('?') ? '&' : '?') + 'width=' + w);
  function imgTag(m, sizes, eager) {
    const set = [400, 600, 800, 1000, 1200, 1600].map((w) => sized(m.src, w) + ' ' + w + 'w').join(', ');
    return (
      '<img src="' + sized(m.src, 1000) + '" srcset="' + set + '" sizes="' + sizes + '" alt="' + esc(cleanAlt(m.alt)) +
      '" width="' + m.w + '" height="' + m.h + '" loading="' + (eager ? 'eager' : 'lazy') + '" draggable="false">'
    );
  }
  function mediaTag(m, sizes, eager) {
    if (m.type === 'video' && m.mp4) {
      return (
        '<video muted loop playsinline preload="metadata"' + (reduceMotion ? '' : ' autoplay') + ' poster="' + sized(m.src, 1000) +
        '" aria-label="' + esc(cleanAlt(m.alt)) + '"><source src="' + m.mp4 + '" type="video/mp4"></video>'
      );
    }
    return imgTag(m, sizes, eager);
  }

  // ---------- render gallery ----------
  function render() {
    const s = compute();
    const key = s.all.map((m) => m.id).join(',') + '|' + s.g + '|' + s.ct;
    if (state && state.key === key) return;
    const keepScroll = grid.scrollLeft;
    const sameSet = state && state.all.map((m) => m.id).join(',') === s.all.map((m) => m.id).join(',');
    s.key = key;
    state = s;

    // v1.4: the "Worn at …" caption shows once in the grid (first model photo); the viewer captions every photo
    const capOn = s.all.find((m) => m.model) || null;
    const nSmall = s.tiles.length - 1;
    grid.dataset.small = String(nSmall);
    grid.innerHTML = s.all
      .map((m, i) => {
        const isTile = i < s.tiles.length;
        const cls = ['mm-gal__shot'];
        if (i === 0) cls.push('mm-gal__shot--main');
        if (!isTile) cls.push('mm-gal__shot--extra');
        cls.push(m.model ? 'mm-gal__shot--model' : 'mm-gal__shot--render');
        if (m.video) cls.push('mm-gal__shot--video');
        if (m === s.t2) cls.push('mm-gal__shot--caratmodel');
        const sizes = i === 0 ? '(min-width: 990px) 55vw, 86vw' : '(min-width: 990px) 27vw, 86vw';
        const cap = m === capOn ? caption(m, s, false) : '';
        const more = isTile && i === s.tiles.length - 1 && s.rest.length ? '<button type="button" class="mm-gal__more" data-mm-more aria-expanded="false">+' + s.rest.length + ' more</button>' : '';
        const play = m.type === 'external_video' || (m.type === 'video' && reduceMotion) ? '<span class="mm-gal__play" aria-hidden="true"></span>' : '';
        return (
          '<figure class="' + cls.join(' ') + '" data-i="' + i + '" tabindex="0" role="button" aria-label="Open ' +
          (m.video ? 'video' : 'photo') + ' ' + (i + 1) + ' of ' + s.all.length + ' full screen">' +
          mediaTag(m, sizes, i === 0) + (cap ? '<figcaption>' + esc(cap) + '</figcaption>' : '') + more + play + '</figure>'
        );
      })
      .join('');
    dots.innerHTML = s.all.map((_, i) => '<span' + (i === 0 ? ' class="on"' : '') + '></span>').join('');
    if (sameSet) grid.scrollLeft = keepScroll;
    else grid.scrollLeft = 0;
    const cm = grid.querySelector('.mm-gal__shot--caratmodel');
    if (cm && state.prevCt !== undefined) cm.classList.add('is-fade');
    state.prevCt = s.ct;
    updateSeeModel();
  }

  // v1.5: "+N more" expands the grid instead of opening the viewer on that tile
  const lessBtn = document.createElement('button');
  lessBtn.type = 'button'; lessBtn.className = 'mm-gal__less'; lessBtn.textContent = 'Show fewer photos'; lessBtn.hidden = true;
  grid.insertAdjacentElement('afterend', lessBtn);
  const setAll = (on) => {
    grid.classList.toggle('is-all', on);
    lessBtn.hidden = !on;
    grid.querySelectorAll('[data-mm-more]').forEach((b) => b.setAttribute('aria-expanded', String(on)));
    if (!on) root.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
  };
  lessBtn.addEventListener('click', () => setAll(false));
  grid.addEventListener('click', (e) => {
    if (e.target.closest('[data-mm-more]')) { e.preventDefault(); e.stopPropagation(); setAll(true); return; }
    const f = e.target.closest('.mm-gal__shot');
    if (f) openLb(Number(f.dataset.i));
  });
  grid.addEventListener('keydown', (e) => {
    const f = e.target.closest('.mm-gal__shot');
    if (e.target.closest('[data-mm-more]')) return;
    if (f && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      openLb(Number(f.dataset.i));
    }
  });
  grid.addEventListener(
    'scroll',
    () => {
      const first = grid.firstElementChild;
      if (!first) return;
      const w = first.getBoundingClientRect().width + 8;
      const i = Math.round(grid.scrollLeft / w);
      [...dots.children].forEach((d, k) => d.classList.toggle('on', k === i));
    },
    { passive: true }
  );

  // ---------- full-screen viewer ----------
  const stage = lb.querySelector('[data-mm-lb-stage]');
  const lbCap = lb.querySelector('[data-mm-lb-cap]');
  let lbI = 0;
  let lastFocus = null;
  function lbRender() {
    const m = state.all[lbI];
    let html;
    if (m.type === 'external_video') {
      const src = m.host === 'youtube' ? 'https://www.youtube.com/embed/' + m.extId + '?autoplay=1&mute=1&playsinline=1' : 'https://player.vimeo.com/video/' + m.extId + '?autoplay=1&muted=1';
      html = '<iframe src="' + src + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="' + esc(cleanAlt(m.alt)) + '"></iframe>';
    } else if (m.type === 'video' && m.mp4) {
      html = '<video controls playsinline autoplay muted loop poster="' + sized(m.src, 1600) + '"><source src="' + m.mp4 + '" type="video/mp4"></video>';
    } else {
      html = '<div class="mm-lb__zoom" data-mm-zoom>' + imgTag(m, '100vw', true) + '</div>';
    }
    stage.innerHTML = html;
    const cap = caption(m, state, true);
    lbCap.textContent = (cap ? cap + '  ·  ' : '') + (lbI + 1) + ' of ' + state.all.length;
  }
  function openLb(i) {
    lastFocus = document.activeElement;
    lbI = i;
    lb.hidden = false;
    document.documentElement.classList.add('mm-lb-open');
    lbRender();
    lb.querySelector('[data-mm-lb-close]').focus();
  }
  function closeLb() {
    lb.hidden = true;
    stage.innerHTML = '';
    document.documentElement.classList.remove('mm-lb-open');
    if (lastFocus) lastFocus.focus();
  }
  function step(d) {
    lbI = (lbI + d + state.all.length) % state.all.length;
    lbRender();
  }
  lb.querySelector('[data-mm-lb-close]').addEventListener('click', closeLb);
  lb.querySelector('[data-mm-lb-prev]').addEventListener('click', () => step(-1));
  lb.querySelector('[data-mm-lb-next]').addEventListener('click', () => step(1));
  lb.addEventListener('click', (e) => {
    if (e.target === lb) closeLb();
  });
  document.addEventListener('keydown', (e) => {
    if (lb.hidden) return;
    if (e.key === 'Escape') closeLb();
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
  });
  // zoom: click/tap toggles 2.2x at the pointer; move to pan
  stage.addEventListener('click', (e) => {
    const z = e.target.closest('[data-mm-zoom]');
    if (!z) return;
    const r = z.getBoundingClientRect();
    z.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
    z.classList.toggle('is-zoomed');
  });
  stage.addEventListener('mousemove', (e) => {
    const z = stage.querySelector('[data-mm-zoom].is-zoomed');
    if (!z) return;
    const r = z.parentElement.getBoundingClientRect();
    z.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
  });
  let tx = null;
  stage.addEventListener('touchstart', (e) => { tx = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
  stage.addEventListener('touchend', (e) => {
    if (tx === null || stage.querySelector('.is-zoomed')) return;
    const dx = e.changedTouches[0].clientX - tx;
    if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
    tx = null;
  });

  // ---------- "See it on the model" (phones only; CSS hides it on desktop) ----------
  let seeBtn = null;
  function updateSeeModel() {
    if (iCarat < 0) return;
    if (!seeBtn) {
      const picker = document.querySelector('variant-selects, variant-radios');
      if (!picker) return;
      const el = picker.querySelectorAll('select')[iCarat] || picker.querySelectorAll('fieldset')[iCarat];
      if (!el) return;
      const anchor = el.closest('.product-form__input, .product-form__controls, fieldset, .select') || el;
      seeBtn = document.createElement('button');
      seeBtn.type = 'button';
      seeBtn.className = 'mm-seemodel';
      seeBtn.textContent = 'See it on the model';
      seeBtn.addEventListener('click', () => {
        const slide = grid.querySelector('.mm-gal__shot--caratmodel');
        if (!slide) return;
        root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        grid.scrollTo({ left: slide.offsetLeft - grid.offsetLeft - 16, behavior: reduceMotion ? 'auto' : 'smooth' });
        slide.classList.remove('is-flash');
        void slide.offsetWidth;
        slide.classList.add('is-flash');
      });
      anchor.insertAdjacentElement('afterend', seeBtn);
    }
    seeBtn.hidden = !(state && state.t2);
  }

  // ---------- follow the selected variant ----------
  function setVariant(v) {
    if (!v) return;
    const next = byId.get(String(v.id)) || { id: v.id, options: v.options, fm: v.featured_media ? v.featured_media.id : null };
    if (cur && String(cur.id) === String(next.id)) return;
    cur = next;
    render();
  }
  document.addEventListener('variant:change', (e) => setVariant(e.detail && e.detail.variant));
  const idInput = () => document.querySelector('form[action*="/cart/add"] [name="id"]');
  const syncFromForm = () => {
    const input = idInput();
    if (input && input.value && (!cur || String(cur.id) !== String(input.value))) setVariant(byId.get(String(input.value)));
  };
  document.addEventListener('change', () => setTimeout(syncFromForm, 80));

  render();
  syncFromForm();
  window.MMGallery = { refresh: () => { state = null; render(); }, state: () => state };
})();
